import { defineMessages } from 'react-intl';

export default defineMessages({
  sizeExtraSmall: 'Rozmiar 1',
  sizeSmall: 'Rozmiar 2',
  sizeMedium: 'Rozmiar 3',
  sizeLarge: 'Rozmiar 4',
  sizeHuge: 'Rozmiar 5',
});
